import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Login from './components/Login';
import SignUp from './components/SignUp';
import HomePage from './components/HomePage';
import AdminLogin from './components/AdminLogin';
import AdminPanel from './components/AdminPanel';
import FloatingChat from './components/FloatingChat';
import FeedPage from './pages/Feed';
import VideosPage from './pages/Videos';
import EditImagePage from './pages/EditImage';
import DashboardPage from './pages/Dashboard';
import ContentsPage from './pages/Contents';
import SchedulingPage from './pages/Scheduling';
import CampaignsPage from './pages/Campaigns';
import BrandIdentityPage from './pages/BrandIdentity';
import TrainAIPage from './pages/TrainAI';
import SettingsPage from './pages/Settings';
import PlansPage from './pages/Plans';
import HelpPage from './pages/Help';
import ManualCreatePage from './pages/ManualCreate';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { TooltipProvider } from './ui/Tooltip/TooltipProvider';
import './App.css';
import './ui/components.css';

function AppContent() {
  const { isLoggedIn, authToken, logout } = useAuth();

  const ProtectedRoute = ({ children }) => {
    if (!isLoggedIn) return <Navigate to="/" replace />;
    return children;
  };

  const ProtectedAdminRoute = ({ children }) => {
    if (!authToken) return <Navigate to="/admin/login" replace />;
    return children;
  };

  const LogoutRoute = () => {
    logout();
    return <Navigate to="/" replace />;
  };

  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={isLoggedIn ? <Navigate to="/home" replace /> : <Login />} />
        <Route path="/signup" element={isLoggedIn ? <Navigate to="/home" replace /> : <SignUp />} />
        <Route path="/logout" element={<LogoutRoute />} />

        <Route
          element={(
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          )}
        >
          <Route path="/home" element={<FeedPage />} />
          <Route path="/manual-create" element={<ManualCreatePage />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/edit-image" element={<EditImagePage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/contents" element={<ContentsPage />} />
          <Route path="/scheduling" element={<SchedulingPage />} />
          <Route path="/campaigns" element={<CampaignsPage />} />
          <Route path="/brand-identity" element={<BrandIdentityPage />} />
          <Route path="/train-ai" element={<TrainAIPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/plans" element={<PlansPage />} />
          <Route path="/help" element={<HelpPage />} />

          <Route path="/conteudos" element={<Navigate to="/contents" replace />} />
          <Route path="/agendamento" element={<Navigate to="/scheduling" replace />} />
          <Route path="/identidade" element={<Navigate to="/brand-identity" replace />} />
          <Route path="/configuracoes" element={<Navigate to="/settings" replace />} />
        </Route>

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={(
            <ProtectedAdminRoute>
              <AdminPanel />
            </ProtectedAdminRoute>
          )}
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {!isAdminRoute && <FloatingChat />}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <TooltipProvider delay={300} mobileTap>
          <Router>
            <AppContent />
          </Router>
        </TooltipProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
